<script>
export default {
  name: 'Footer',
  computed:{
    actualYear(){
      let date = new Date
      let year = date.getFullYear()
      return year
    }
  }
}
</script>


<template>
  <div class="footerContainer">
    <div>&copy; Sphem 2015 - {{actualYear}}</div>
  </div>
</template>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../assets/main.scss';

.footerContainer{
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  @include myFont;
  font-size: 13px;
  color: $black-bold;
  margin: 20px 0 10px 0;
  flex: 1;
}

</style>
